import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, Typography, Breadcrumbs as MUIBreadcrumbs } from '@mui/material';
import { piiProps } from 'src/components/DemoBlur';

// ----------------------------------------------------------------------

export default function Breadcrumbs({ links, activeLast = false, ...other }) {
    const currentLink = links[links.length - 1].name;

    const listDefault = links.map((link) => <LinkItem key={link.name} link={link} />);

    const listActiveLast = links.map((link) => (
        <div key={link.name}>
            {link.name !== currentLink ? (
                <LinkItem link={link} />
            ) : (
                <Typography
                    variant="body2"
                    {...(links[links.length - 1].pii ? piiProps : {})}
                    sx={{
                        maxWidth: 260,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        color: 'text.disabled',
                        textOverflow: 'ellipsis',
                        textTransform: 'capitalize'
                    }}
                >
                    {currentLink}
                </Typography>
            )}
        </div>
    ));

    return (
        <MUIBreadcrumbs
            separator={<Box component="span" sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: 'text.disabled' }} />}
            {...other}
        >
            {activeLast ? listDefault : listActiveLast}
        </MUIBreadcrumbs>
    );
}


function LinkItem({ link }) {
    const { href, name, icon, pii } = link;
    // Crumbs without an href (e.g. nav-group labels like "Active Leads") are plain
    // text, not dead '#' links.
    if (!href) {
        return (
            <Typography
                key={name}
                variant="body2"
                {...(pii ? piiProps : {})}
                sx={{ lineHeight: 2, display: 'flex', alignItems: 'center', color: 'text.secondary' }}
            >
                {icon && <Box sx={{ mr: 1, '& svg': { width: 20, height: 20 } }}>{icon}</Box>}
                {name}
            </Typography>
        );
    }
    return (
        <Link
            key={name}
            variant="body2"
            component={RouterLink}
            to={href}
            {...(pii ? piiProps : {})}
            sx={{
                lineHeight: 2,
                display: 'flex',
                alignItems: 'center',
                color: 'text.primary',
                '& > div': { display: 'inherit' },
            }}
        >
            {icon && <Box sx={{ mr: 1, '& svg': { width: 20, height: 20 } }}>{icon}</Box>}
            {name}
        </Link>
    );
}

// ----------------------------------------------------------------------

LinkItem.propTypes = {
    link: PropTypes.shape({
        href: PropTypes.string,
        icon: PropTypes.any,
        name: PropTypes.string,
        pii: PropTypes.bool,
    }),
};

Breadcrumbs.propTypes = {
    activeLast: PropTypes.bool,
    links: PropTypes.array.isRequired,
};